export default {
    'searchList': {
        'searchTxt': [{
            'name': '客户订单号',
            'value': 'ettaSoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '运输单号',
            'value': 'ettaNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '物流订单号',
            'value': 'ettaOrderNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'timeNum': 30,
            'type': 'time',
            'unfold': true,
            'span': 6
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '终端收货单位',
                'prop': 'eoorConsigneeName',
                'sort': true,
                'width': '160px'
            },
            {
                'label': '终端收货省',
                'prop': 'eoorConsigneeProvinceName',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '终端收货市',
                'prop': 'eoorConsigneeCityName',
                'sort': true,
                'width': '120px'
            },
            {
                'label': '终端收货区县',
                'prop': 'eoorConsigneeDistrictName',
                'sort': true,
                'width': '130px'
            },
            {
                'label': '终端详细地址',
                'prop': 'eoorConsigneeLocationName',
                'sort': true,
                'width': '200px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '集拼号',
                'prop': 'ettaAssighNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装车排序',
                'prop': 'loadingSeq',
                'sort': true,
                'width': '148px'
            },
            {
                'label': 'CIMS集拼号',
                'prop': 'cimsVampNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户订单号',
                'prop': 'ettaSoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单号',
                'prop': 'ettaNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '线路',
                'prop': 'ettaEblnLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货单位',
                'prop': 'ettaConsigneeEbspNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '集拼单数',
                'prop': 'cimsVampOrderCount',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '体积',
                'prop': 'ettaVolume',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '数量',
                'prop': 'ettaQuantity',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '重量',
                'prop': 'ettaWeight',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货仓库',
                'prop': 'ettaOutWhName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系电话',
                'prop': 'ettaToContactTel',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单送达地址',
                'prop': 'ettaEtorToEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '备注',
                'prop': 'ettaRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求送达时间',
                'prop': 'ettaReqArrivalDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求发货时间',
                'prop': 'ettaReqDeliveryDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '送达区域',
                'prop': 'esstToCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输方式',
                'prop': 'ettaTranTypeNew',
                'sort': true,
                'width': '148px'
            },
            {
                'label': 'C端业务类型',
                'prop': 'ettaBusinessTypeNew',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否供方预约',
                'prop': 'etIsSupllyAppointmentType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输产品',
                'prop': 'etCimsTmsProduct',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否预约',
                'prop': 'ettaReservationType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单状态',
                'prop': 'ettaStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单类型',
                'prop': 'ettaOrderTypeName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货地',
                'prop': 'ettaEtorFromEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '提货区域',
                'prop': 'esstFromCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '紧急程度',
                'prop': 'ettaLevelType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '物流订单号',
                'prop': 'ettaOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '网点名称',
                'prop': 'ettaTargetEsstName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '仓库库区',
                'prop': 'ettaWarehouseRegion',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '品类名称',
                'prop': 'ettaItemName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约异常',
                'prop': 'businessCode',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户预约单号',
                'prop': 'ettaReservationNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约送货时间',
                'prop': 'ettaReservationTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系手机',
                'prop': 'ettaToContactMobile',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '下发承运商时间',
                'prop': 'ettaCarrierIssueTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '买家地址',
                'prop': 'esstToSaleAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '交接单号',
                'prop': 'ettaJoinElsNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': 'T+3标志',
                'prop': 'ettaIsT3',
                'sort': true,
                'width': '148px'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '终端收货单位',
            'value': 'eoorConsigneeName',
            'type': 'input'
        },
        {
            name: '终端收货地',
            value: 'receiverCode',
            config: {
                checkStrictly: true
            },
            type: 'addressSelect3',
            minLayers: 2
        },
        {
            'name': '发货日期≦',
            'value': 'ettaReqDeliveryDateT',
            'type': 'date',
            'unfold': false,
            'span': 3
        }, {
            'name': '集拼号',
            'value': 'ettaAssighNo',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': '线路',
            'value': 'eblnLineName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' }
            ],
            'tableConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' },
                { 'prop': 'eblnRatedMileage', 'value': '额定里程' }
            ],
            'advanceUrl': '/ebLine/search',
            'cbParams': ['eblnLineCode#ettaEblnCode', 'eblnLineName', 'eblnRatedMileage'],
            'span': 4
        }, {
            'name': '是否菜鸟',
            'value': 'status',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'S_F_FLAG',
            'multiple': false
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#ettaCustomEbcuNo', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '订单类型',
            'value': 'ettaOrderType',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'LMS_ORDER_TYPE',
            'multiple': false
        }, {
            'name': '装货仓库',
            'value': 'whName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'tableConfig': [
                { 'prop': 'whCode', 'value': '仓库编码' },
                { 'prop': 'cdwhName', 'value': '仓库名称' }
            ],
            'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
            'cbParams': [
                'whCode#ettaOutWhCode', 'cdwhName#whName'
            ],
            'type': 'advance',
            'advanceCode': 'cdwhName'
        }, {
            'name': '仓库库区',
            'value': 'ettaWarehouseRegion',
            'type': 'input',
            'unfold': false,
            'span': 3
        }, {
            'name': 'C端业务类型',
            'value': 'ettaBusinessType',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'ETTA_BUSINESS_TYPE',
            'multiple': false
        }, {
            'name': 'C端配送方式',
            'value': 'ettaDeliveryTypeCode',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'OMS_TRANS_TYPE',
            'multiple': false
        }, {
            'name': '是否预约',
            'value': 'ettaReservation',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'SYS_SUPPLIER_YES_NO',
            'multiple': false
        }, {
            'name': '订单来源',
            'value': 'ettaOrderSource',
            'type': 'select',
            'unfold': false,
            'span': 3,
            'optionNum': 'SYS_TMS_ORDER_SOURCE',
            'multiple': false
        }, {
            'name': '交接单号',
            'value': 'ettaJoinElsNos',
            'type': 'input',
            'unfold': false,
            'span': 3
        }
    ],
    'viewBillBasicData': {
        'carNumber': {
            'method': 'post',
            'name': '必填',
            'advanceLabel': '车牌号',
            'value': 'etdoVehicleCard',
            'advanceConfig': [
                { 'prop': 'licensePlateNo', 'value': '车牌' },
                { 'prop': 'maxVolume', 'value': '载货体积' },
                { 'prop': 'carTypeNameCn', 'value': '车型' },
                { 'prop': 'carType', 'value': '车型编码' }
            ],
            'tableConfig': [
                { 'prop': 'licensePlateNo', 'value': '车牌' },
                { 'prop': 'maxVolume', 'value': '载货体积' },
                { 'prop': 'carTypeNameCn', 'value': '车型' },
                { 'prop': 'carType', 'value': '车型编码' }
            ],
            'prefix': '/api-srm-web/',
            'advanceUrl': 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
            'cbParams': [
                'licensePlateNo#etdoVehicleCard', 'carTypeNameCn#etdoEquipmentName', 'carType#etdoEquipmentType'
            ],
            'advanceCascade': 'supplierCode,routeNoList'
        },
        'driverLists': {
            'method': 'post',
            'name': '请输入司机',
            'advanceLabel': '司机',
            'value': 'etdoMainDriver',
            'advanceConfig': [
                { 'prop': 'driverName', 'value': '司机' },
                { 'prop': 'driverPhone', 'value': '电话' },
                { 'prop': 'driverCode', 'value': 'DN编码' },
                { 'prop': 'driverIdCard', 'value': '身份证号' }
            ],
            'tableConfig': [
                { 'prop': 'driverName', 'value': '司机' },
                { 'prop': 'driverPhone', 'value': '电话' },
                { 'prop': 'driverCode', 'value': 'DN编码' },
                { 'prop': 'driverIdCard', 'value': '身份证号' }
            ],
            'prefix': '/api-srm-web/',
            'advanceUrl': 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
            'cbParams': [
                'driverName#etdoMainDriver', 'driverCode#etdoMainDriverNo', 'driverPhone#etdoMainDriverContactWay'
            ],
            'advanceCascade': 'supplierCode,routeNoList'
        }
    }
};
